import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { STATUS, getCountdown, getLoader, HOSTS } from './../lib/helper'
import _ from 'underscore'

class PressableCompleted extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			ignoredFiles: [],
			pagination: {},
			stats: {},
			currentPage: 1,
			loading: true,
			error: null,
			showIgnoredFiles: false
		}
		this.fetchIgnoredFiles = this.fetchIgnoredFiles.bind(this)
		this.handlePageChange = this.handlePageChange.bind(this)
		this.toggleIgnoredFiles = this.toggleIgnoredFiles.bind(this)
	}

	componentDidMount() {
		this.fetchIgnoredFiles(1)
	}

	fetchIgnoredFiles(page = 1) {
		const { migrate, actions, match } = this.props
		const gid = migrate.get('gid')
		const key = match.params.gid
		
		this.setState({ loading: true, error: null })
		
		actions.fetchIgnoredFiles({ key: key, page: page, per_page: 20 })
			.then(response => {
				this.setState({
					ignoredFiles: response.data.ignored_files || [],
					pagination: response.data.pagination || {},
					stats: response.data.stats || {},
					currentPage: page,
					loading: false
				})
			})
			.catch(error => {
				console.error('Error fetching ignored files:', error)
				this.setState({
					loading: false,
					error: 'Failed to load ignored files data'
				})
			})
	}

	handlePageChange(newPage) {
		if (newPage >= 1 && newPage <= this.state.pagination.total_pages) {
			this.fetchIgnoredFiles(newPage)
		}
	}

	toggleIgnoredFiles() {
		this.setState(prevState => ({
			showIgnoredFiles: !prevState.showIgnoredFiles
		}))
	}

	renderMigrationStatusSection() {
		const { migrate } = this.props
		return (
			<div>
				{/* Migration Status Section */}
				<div className="migration-status-section">
					<h1 className="success-title">Migration Completed Successfully!</h1>

					<div className="migration-flow">
						<div className="source-site">
							<span className="site-url">{migrate.get('source_site')}</span>
						</div>

						<div className="migration-arrow">
							<i className="mdi mdi-arrow-right-thick"></i>
						</div>

						<div className="destination-site">
							<span className="site-url">{migrate.get('destination_site')}</span>
						</div>

						<div className="visit-site">
							<a href={migrate.get('destination_site')} 
								className="visit-site-button">
								<i className="mdi mdi-open-in-new"></i> Visit Site
							</a>
							{migrate.get('destination_host') === HOSTS.PANTHEON && (
								<a href={migrate.get('migration_completed_link')} 
									className="dashboard-button">
									<i className="mdi mdi-view-dashboard"></i> Dashboard
								</a>
							)}
						</div>
					</div>
				</div>
			</div>
		)
	}

	renderPagination() {
		const { pagination } = this.state
		
		if (!pagination.total_pages || pagination.total_pages <= 1) {
			return null
		}

		return (
			<div style={{ 
				display: 'flex', 
				justifyContent: 'center', 
				alignItems: 'center', 
				gap: '10px', 
				marginTop: '20px' 
			}}>
				<button 
					onClick={() => this.handlePageChange(pagination.current_page - 1)}
					disabled={!pagination.has_prev}
					style={{ 
						padding: '8px 12px', 
						border: '1px solid #dee2e6', 
						background: pagination.has_prev ? '#fff' : '#f8f9fa',
						cursor: pagination.has_prev ? 'pointer' : 'not-allowed',
						borderRadius: '4px'
					}}
				>
					Previous
				</button>
				
				<span style={{ margin: '0 15px', color: '#6c757d' }}>
					Page {pagination.current_page} of {pagination.total_pages}
				</span>
				
				<button 
					onClick={() => this.handlePageChange(pagination.current_page + 1)}
					disabled={!pagination.has_next}
					style={{ 
						padding: '8px 12px', 
						border: '1px solid #dee2e6', 
						background: pagination.has_next ? '#fff' : '#f8f9fa',
						cursor: pagination.has_next ? 'pointer' : 'not-allowed',
						borderRadius: '4px'
					}}
				>
					Next
				</button>
			</div>
		)
	}

	renderStatsBox() {
		const { ignoredFiles } = this.state
		
		return (
			<div style={{ marginBottom: '20px' }}>
				<div style={{ 
					display: 'flex', 
					alignItems: 'center', 
					justifyContent: 'space-between',
					marginBottom: '15px' 
				}}>
					<h3 style={{ margin: 0, color: '#495057' }}>
						Files Not Migrated ({this.state.pagination.total_count} total)
					</h3>
					<button
						onClick={this.toggleIgnoredFiles}
						style={{
							padding: '8px 16px',
							border: '1px solid #dee2e6',
							background: '#fff',
							borderRadius: '4px',
							cursor: 'pointer',
							color: '#495057'
						}}
					>
						{this.state.showIgnoredFiles ? 'Hide Details' : 'Show Details'}
					</button>
				</div>
				{!this.state.showIgnoredFiles && (
					<p style={{ margin: 0, color: '#6c757d' }}>
						Click "Show Details" to see the list of files that were not migrated.
					</p>
				)}
			</div>
		)
	}

	renderIgnoredFilesTable() {
		const { ignoredFiles, loading, error } = this.state

		if (loading) {
			return (
				<div style={{ textAlign: 'center', padding: '40px' }}>
					{getLoader()}
				</div>
			)
		}

		if (error) {
			return (
				<div style={{ 
					textAlign: 'center', 
					padding: '40px', 
					color: '#dc3545',
					background: '#f8d7da',
					border: '1px solid #f5c6cb',
					borderRadius: '4px'
				}}>
					{error}
				</div>
			)
		}

		if (ignoredFiles.length === 0) {
			return (
				<div style={{ 
					textAlign: 'center', 
					padding: '40px', 
					color: '#6c757d',
					background: '#f8f9fa',
					border: '1px solid #dee2e6',
					borderRadius: '4px'
				}}>
					No files were ignored during migration
				</div>
			)
		}

		return (
			<div>
				<table style={{ 
					width: '100%', 
					borderCollapse: 'collapse',
					border: '1px solid #dee2e6',
					borderRadius: '8px',
					overflow: 'hidden'
				}}>
					<thead>
						<tr style={{ background: '#e9ecef' }}>
							<th style={{ 
								padding: '12px', 
								textAlign: 'left', 
								borderBottom: '1px solid #dee2e6',
								fontWeight: '600',
								width: '40%'
							}}>
								Name
							</th>
							<th style={{ 
								padding: '12px', 
								textAlign: 'left', 
								borderBottom: '1px solid #dee2e6',
								fontWeight: '600',
								width: '60%'
							}}>
								Reason
							</th>
						</tr>
					</thead>
					<tbody>
						{ignoredFiles.map((file, index) => (
							<tr key={index} style={{ 
								borderBottom: index < ignoredFiles.length - 1 ? '1px solid #dee2e6' : 'none',
								background: index % 2 === 0 ? '#fff' : '#f8f9fa'
							}}>
								<td style={{ 
									padding: '12px', 
									wordBreak: 'break-all',
									fontFamily: 'monospace',
									fontSize: '13px'
								}}>
									{file.filename || 'N/A'}
								</td>
								<td style={{ 
									padding: '12px',
									color: '#6c757d'
								}}>
									{file.reason || 'No reason provided'}
								</td>
							</tr>
						))}
					</tbody>
				</table>
				{this.renderPagination()}
			</div>
		)
	}

	render() {
		const { migrate } = this.props

		return (
			<div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
				{/* Migration Status and Review Sections from MgCompleted */}
				{this.renderMigrationStatusSection()}

				{/* Ignored Files Section */}
				<div>
					{this.renderStatsBox()}
					{this.state.showIgnoredFiles && this.renderIgnoredFilesTable()}
				</div>

				{/* Styles from MgCompleted */}
				<style>{`
					.migration-status-section {
						background: #f8f9fa;
						padding: 25px;
						border-radius: 12px;
						margin-bottom: 30px;
						box-shadow: 0 2px 4px rgba(0,0,0,0.05);
					}

					.success-title {
						font-size: 24px;
						color: #2c3338;
						margin: 0 0 20px 0;
						text-align: center;
					}

					.migration-flow {
						display: flex;
						align-items: center;
						gap: 15px;
						flex-wrap: nowrap;
						background: white;
						padding: 15px;
						border-radius: 8px;
					}

					.source-site, .destination-site {
						flex: 1;
						min-width: 0;
					}

					.site-url {
						display: block;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						color: #1a202c;
						font-size: 15px;
					}

					.migration-arrow {
						color: #48BB78;
						flex-shrink: 0;
						font-size: 20px;
						padding: 0 10px;
					}

					.visit-site {
						flex-shrink: 0;
						display: flex;
						gap: 10px;
					}

					.visit-site-button, .dashboard-button {
						display: flex;
						align-items: center;
						gap: 8px;
						padding: 8px 16px;
						border-radius: 6px;
						text-decoration: none;
						color: white;
						font-size: 14px;
						transition: all 0.3s ease;
					}

					.visit-site-button {
						background: #4CAF50;
					}

					.dashboard-button {
						background: #3498db;
					}

					.visit-site-button:hover, .dashboard-button:hover {
						transform: translateY(-1px);
						box-shadow: 0 4px 12px rgba(0,0,0,0.1);
					}

					.mg-review-section {
						margin-top: 30px;
						padding: 15px 20px;
						background: #f8f9fa;
						border-radius: 8px;
						margin-bottom: 30px;
					}

					.review-content {
						display: flex;
						align-items: center;
						justify-content: space-between;
						gap: 20px;
					}

					.review-title {
						font-size: 16px;
						color: #2d3748;
						white-space: nowrap;
						display: flex;
						align-items: center;
						gap: 8px;
					}

					.heart {
						color: #ff6b6b;
					}

					.review-actions {
						display: flex;
						align-items: center;
						gap: 12px;
					}

					.review-button, .help-button {
						padding: 6px 12px;
						border: 1px solid #cbd5e0;
						border-radius: 6px;
						text-decoration: none;
						color: #4a5568;
						font-size: 14px;
						transition: all 0.3s ease;
						background: white;
						display: flex;
						align-items: center;
						gap: 5px;
					}

					.review-button:hover, .help-button:hover {
						background: #f7fafc;
						border-color: #a0aec0;
						transform: translateY(-1px);
					}

					@media (max-width: 768px) {
						.migration-flow {
							flex-direction: column;
							align-items: stretch;
							gap: 10px;
						}

						.migration-arrow {
							transform: rotate(90deg);
							text-align: center;
							padding: 5px 0;
						}

						.visit-site {
							flex-direction: column;
							width: 100%;
						}

						.visit-site-button,
						.dashboard-button {
							justify-content: center;
						}

						.site-url {
							text-align: center;
						}

						.review-content {
							flex-direction: column;
							gap: 15px;
							text-align: center;
						}

						.review-title {
							justify-content: center;
						}

						.review-actions {
							flex-wrap: wrap;
							justify-content: center;
						}
					}
				`}</style>
			</div>
		)
	}
}

PressableCompleted.propTypes = {
	migrate: ImmutablePropTypes.map.isRequired,
	actions: PropTypes.object,
	match: PropTypes.object
}

export default PressableCompleted 